import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DATETIME_FORMAT_DATE } from '../utils/helpers/CommonHelper';
import dayjs from 'dayjs';

export function useFoWorkshopBasicInformation(workshopDetail) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!workshopDetail) return [];

    return [
      {
        label: t('Názov akcie'),
        value: workshopDetail.event.name,
      },
      {
        label: t('Trvanie akcie'),
        value:
          dayjs(workshopDetail.event.date_from).format(DATETIME_FORMAT_DATE) +
          ' - ' +
          dayjs(workshopDetail.event.date_to).format(DATETIME_FORMAT_DATE),
      },
      {
        label: t('Názov seminára'),
        value: workshopDetail.name,
      },
      {
        label: t('Lektor seminára'),
        value: workshopDetail.lecturer.displayname,
      },
      {
        label: t('Popis'),
        value: workshopDetail.description,
        isRaw: true,
      },
    ];
  }, [workshopDetail, t]);
}
